module.exports = __webpack_public_path__ + "assets/media/edit_category_icon.457cf5dc.svg";